import React, { useMemo, useState, useEffect } from "react";
import { Col, Row, Card, Dropdown, Table, Spinner } from "react-bootstrap";
import "./UserLandingPage.css";
import UserLandingPageCard from "./UserLandingPageCard";
import firstTitleIcon from "../../../assets/images/user-landing-page/first-title-icon.svg";
import secondTitleIcon from "../../../assets/images/user-landing-page/second-title-icon.svg";
import thirdTitleIcon from "../../../assets/images/user-landing-page/third-title-icon.svg";
import barIcon from "../../../assets/images/barIcon.svg";
import handIcon from "../../../assets/images/hand-color-icon.webp";
import { useCookies } from "react-cookie";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import programCordinatorIcon from "../../../assets/images/user-landing-page/program_coord.png";
import Updates from "./Updates";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import {
  fetchCordinatorMatric,
  fetchIndividualTrainingProgram,
  fetchTrainingProgramProgress,
} from "ServerAPI/serverAPI";

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import _ from "lodash";
import SharedTable from "components/table/SharedTable";
import { useNavigate } from "react-router-dom";
import ProgressCard from "./ProgressCard";
import TraingingProgramProgress from "./TraingingProgramProgress";
import TrainingProgramAnalysis from "./TrainingProgramAnalysis";
import { CircularProgress } from "@mui/material";
import TrainingProgramProgress from "./TrainingProgramProgress";

const muiColumns = [
  {
    field: "userGroupName",
    headerName: "Training Program Name",
    flex: 1,
    resizable: false,
    headerClassName: "header",
    hideable: false,
    filterable: false,
  },
  {
    field: "totalUsers",
    headerName: "No. of Users",
    type: "number",
    flex: 0.5,
    resizable: false,
    hideable: false,
    filterable: false,
    headerClassName: "header",
  },
  {
    field: "courses",
    headerName: "Course Assigned",
    flex: 1.5,
    resizable: false,
    hideable: false,
    filterable: false,
    headerClassName: "header",
  },
  {
    field: "courseDepartment",
    headerName: "Course Department",
    flex: 1,
    resizable: false,
    hideable: false,
    filterable: true,
    headerClassName: "header",
  },
  {
    field: "completionPercentage",
    headerName: "Completion(%)",
    flex: 1,
    resizable: false,
    hideable: false,
    filterable: true,
    headerClassName: "header",
    disableColumnMenu: true,
  },
];

const ProgramCordinator = ({ metricsDetails }) => {
  const [cookies] = useCookies();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataRows, setDataRows] = useState();
  const [fixedDataRows, setFixedDataRows] = useState();
  const [totalCourses, setTotalCourses] = useState(0);
  const [totalPrograms, setTotalPrograms] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [trainingProgramProgress, settrainingProgramProgress] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [loadTable, setLoadTable] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [loadTableOnly, setLoadTableOnly] = useState(false);
  const navigate = useNavigate();
  const [showTable, setShowTable] = useState(true);
  const [activeTrainingProgramCard, setActiveTrainingProgramCard] =
    useState(null);
  const [questions, setQuestions] = useState([]);

  const columns = useMemo(
    () => [
      // { accessorKey: "id", header: "Sl. No.", size: 200 },
      {
        accessorKey: "name",
        header: "Training Program Name",
        cell: ({ row }) => (
          <div style={{ fontWeight: 700 }}>{row.original.name}</div>
        ),
      },
      {
        accessorKey: "courseParticipantsCount",
        header: "Course Participants Count",
      },
    ],
    []
  );

  const deBounedhandleSearch = (e) => {
    console.log("fjerjf", e.target.value);

    if (e.target.value.length === 0) {
      setDataRows(fixedDataRows);
      return;
    }
    const allDataRows = [...fixedDataRows];
    const result = allDataRows.filter((row) => {
      return row.name.toLowerCase().includes(e.target.value.toLowerCase());
    });
    setDataRows(result);
  };

  const handleSearch = _.debounce(deBounedhandleSearch, 500);

  const onClickHander = (path) => {
    navigate(path);
  };
  const getCordinatorMatric = async () => {
    const response = await fetchCordinatorMatric(cookies.userId);
    if (response.status === 200) {
      setTotalCourses(response.data?.[0]?.totalCourses);
      setTotalPrograms(response.data?.[0]?.totalPrograms);
      setTotalUsers(response.data?.[0]?.totalUsers);
    }
  };

  const getTrainingProgramProgress = async (
    groupId = "",
    fetchTableDataOnly = false
  ) => {
    if (groupId || fetchTableDataOnly) {
      setLoadTable(true);
    } else {
      setShowLoader(true);
    }

    const response = await fetchTrainingProgramProgress(cookies.userId);
    if (response.status === 200) {
      settrainingProgramProgress(response?.data);
      if (selectedGroup === null) {
        setSelectedGroup(response.data?.[0]);
      }
    }

    const result = await fetchIndividualTrainingProgram(
      cookies.userId,
      groupId ? groupId : response.data?.[0]?.userGroupId
    );
    if (result.status === 200) {
      setQuestions(result.data.questions.questions);
      const formattedRows = result?.data?.userData?.map((row, index) => {
        return {
          ...row,
          progress: row?.progress?.toFixed(2),
          id: index + 1,
        };
      });

      setDataRows(formattedRows);
      setFixedDataRows(formattedRows);
    }
    setShowLoader(false);
    setLoadTable(false);
  };

  useEffect(() => {
    getCordinatorMatric();
    getTrainingProgramProgress();
  }, []);
  const fetchOverAllDetails = async (groupId) => {
    setLoadTableOnly(true);
    const result = await fetchIndividualTrainingProgram(
      cookies.userId,
      groupId
    );
    if (result.status === 200) {
      const formattedRows = result?.data?.userData?.map((row, index) => {
        return {
          ...row,
          progress: row?.overallProgress.toFixed(2),
          id: index + 1,
        };
      });

      setDataRows(formattedRows);
      setFixedDataRows(formattedRows);
    }
    setLoadTableOnly(false);
  };
  const handleClick = (userGroupId, group) => {
    setActiveTrainingProgramCard(1);
    setSelectedGroup(group);
    fetchOverAllDetails(userGroupId);
  };

  const fetchIndividualCourseDetails = async (courseId) => {
    setLoadTableOnly(true);
    const result = await fetchIndividualTrainingProgram(
      cookies.userId,
      selectedGroup?.userGroupId,
      courseId
    );
    if (result.status === 200) {
      setQuestions(result.data.questions.questions);
      const formattedRows = result?.data?.userData?.map((row, index) => {
        return {
          ...row,
          progress: row?.progress?.toFixed(2),
          id: index + 1,
        };
      });

      setDataRows(formattedRows);
      setFixedDataRows(formattedRows);
      setShowTable(true);
    }
    setLoadTableOnly(false);
  };

  const handleCourseChange = (e) => {
    if (e.target.value) {
      fetchIndividualCourseDetails(e.target.value);
    }
  };

  return (
    <>
      {showLoader ? (
        <>
          <div className="d-flex justify-content-center mt-5">
            <CircularProgress />
          </div>
        </>
      ) : (
        <>
          {" "}
          <div>
            <Card className="mt-5">
              <Card.Body>
                <Row>
                  <Col xl={4} lg={6} md={12} sm={12}>
                    <UserLandingPageCard
                      title="COURSES"
                      titleIcon={firstTitleIcon}
                      barIcon={barIcon}
                      value={totalCourses}
                      viewText="View all"
                      quantity="40%"
                      removedText="12 Trainees removed"
                      addedText="10 Trainees added"
                    />
                  </Col>

                  <Col xl={4} lg={6} md={12} sm={12}>
                    <UserLandingPageCard
                      title="PARTICIPANTS"
                      titleIcon={secondTitleIcon}
                      barIcon={barIcon}
                      value={totalUsers}
                      viewText="View all"
                      quantity=""
                      removedText="12 Trainees removed"
                      addedText="10 Trainees added"
                    />
                  </Col>
                  <Col xl={4} lg={6} md={12} sm={12}>
                    <UserLandingPageCard
                      title="ACTIVE TRAINING PROGRAMS"
                      titleIcon={thirdTitleIcon}
                      barIcon={barIcon}
                      value={totalPrograms}
                      viewText="View all"
                      quantity=""
                      removedText="12 Trainees removed"
                      addedText="10 Trainees added"
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <div className="mt-5">
              {/* <TraingingProgramProgress
                data={trainingProgramProgress}
                handleClick={handleClick}
              /> */}

              <TrainingProgramProgress
                questions={questions}
                data={trainingProgramProgress}
                rows={dataRows}
                handleSearch={handleSearch}
                handleClick={handleClick}
                loadingTable={loadTable}
                selectedGroup={selectedGroup}
                handleCourseChange={handleCourseChange}
                loadTableOnly={loadTableOnly}
                showTable={showTable}
                setShowTable={setShowTable}
                fetchOverAllData={getTrainingProgramProgress}
                activeTrainingProgramCard={activeTrainingProgramCard}
                setActiveTrainingProgramCard={setActiveTrainingProgramCard}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProgramCordinator;
